import { createFileRoute } from "@tanstack/react-router";
import CardSharePage from "@/site/pages/card-share";

/**
 * The public share view of a received card (legacy `/card/share/view/<magic_link>`):
 * the card and its messages only. `$slug` is the send's share slug — or, for links
 * shared before the cutover, the legacy magic link (= read slug).
 */
export const Route = createFileRoute("/card/share/view/$slug")({
  component: CardSharePage,
});
